import { Picture } from "../../../Components/PhotosApp/PhotoViewer/PhotoInterfaces";
import pfp1 from "./EverestTweeterAssets/Tweeter-pfp-01.webp"; // Corrected path
import post1 from "./EverestTweeterAssets/tweeter-post-01.webp"; // Corrected path
import pfp2 from "./EverestTweeterAssets/Tweeter-pfp-02.webp"; // Corrected path
import post2 from "./EverestTweeterAssets/tweeter-post-02.webp"; // Corrected path
import pfp3 from "./EverestTweeterAssets/tweeter-pfp-03.webp"; // Corrected path
import post3 from "./EverestTweeterAssets/tweeter-post-03.webp"; // Corrected path

export interface Comment {
  icon?: string;
  date: string;
  author: string;
  handle: string;
  likes: number;
  content: string;
}

export interface Tweet {
  icon?: string;
  date: string;
  time: string;
  author: string;
  handle: string;
  verified: string;
  content: string | Picture;
  contentImage?: string;
  likes: number;
  retweets: number;
  quotes: number;
  comments?: Comment[];
}

// Changed from NancyTweetContent to EverestTweetContent
export const EverestTweetContent: Tweet[] = [
  {
    icon: pfp1,
    date: "14 June 2025",
    time: "3:15 PM",
    author: "Amapa Reserve",
    handle: "@amapaecuador",
    verified: "Verified.webp",
    content:
      "Come to our conference on Friday to learn more about permaculture with our special guest speaker @laura_ortega",
    contentImage: post1,
    likes: 2100,
    retweets: 43,
    quotes: 5,
  },
  {
    icon: pfp2,
    date: "19 June 2025",
    time: "11:44 PM",
    author: "Virna Pizarro",
    handle: "@virnapiz4rro",
    verified: "",
    content: "Very grateful to be reunited with my dad",
    contentImage: post2,
    likes: 986,
    retweets: 162,
    quotes: 2,
  },
  {
    icon: pfp3,
    date: "21 June 2024",
    time: "4:02 PM",
    author: "Nature International",
    handle: "@natureint",
    verified: "Verified.webp",
    content:
      "40 incidents reported of illegal whaling in Japan already this year.",
    contentImage: post3,
    likes: 3400,
    retweets: 182000,
    quotes: 55,
  },
];
